import Grid from 'styled-components-grid';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { colors } from '@components/ListItemFacility/styles';

export const StyledBarWrapper = styled(Grid)`
  margin: 0 auto;
  margin-top: 100px;
  width: 400px;

  ${breakpoint('mobile', 'tablet')`
    width: 200px;
    margin-top: 30px;
     ${({ homePage }) => homePage && `
      margin-top: 0px;
     `}
  `}
  ${({ homePage }) => homePage && `
    justify-content: center;
    margin-top: 0;
    padding-bottom: 1rem;
  `}
  ${({ pagination }) => pagination && `
    margin : 0rem;
    padding-bottom: 0rem;
  `}
`;

export const StyledSinglebar = styled(Grid.Unit)`
  padding: 10px;
  .active {
    width: 100%;
    transition: ${props => (props.homePage ? '' : '4s')};
  }

  .unactive {
    width: 0px;
  }
  max-width:${props => (props.homePage ? '10%' : '')};
`;

export const StyledBackColorFill = styled.div`
  cursor: pointer;
  height: ${props => (props.homePage ? '10px' : '5px')};
  border-radius:  ${props => (props.homePage ? '50%' : '8px')};
  width: ${props => (props.homePage ? '10px' : 'calc(100% - 20px)')}; 
  background-color: ${props => (props.homePage ? '#a6adbc' : colors.gray)};
  ${({ pagination }) => pagination && `
    height: 15px;
    width: 15px;
  `}

`;

export const StyledColorFill = styled.div`
  height: ${props => (props.homePage ? '10px' : '5px')};
  border-radius: ${props => (props.homePage ? '50%' : '8px')};
  background-color: ${props => props.color || `${colors.newThemeDarkBlue}`};

  ${({ pagination }) => pagination && `
    height: 15px;
    background-color: #5FA6BF;
  `}

`;
